export default {
  title: '应用场景',
      sidebar: {
        title: '应用领域'
      },
      magnetic: {
        title: '磁体应用',
        introduction: {
          title: '引言',
          content: `超导材料是人们产生强磁场的关键基础材料，在数特斯拉乃至数十特斯拉等级的强磁场应用领域，往往都需要超导导线来绕着磁体。高温超导材料更是有望规模化应用到能源、交通、大科学仪器等众多领域。
          科研用高强超导磁体主要包括大口径高场超导导体与磁体、内插高温超导磁体、CICC导体等，可应用于大科学工程、生物医学工程、高精度科学仪器等领域。REBCO带材在高场下具有更高的电流传输能力和更优异的机械性能，更适宜做高场磁体（≥25T），有望推动整个科学技术的进步与发展。

      粒子加速器及重离子癌症治疗系统的核心部件是磁体，在磁场中将粒子加速碰撞或释放高能射线，从而达到科研、治疗的目的。REBCO高温超导磁体具有体积小、重量轻、无需液氦制冷等突出优势，是下一代加速器装置的首选。

      超导风力发电机主要利用高温超导带材的零电阻特性，使用高温超导线圈替代铜线圈， 具有体积小、重量轻、整机成本低等优势，适合于海上风机和漂浮式风机。超导风力发电机是最有潜力、最理想的能源转换装置之一，将进一步推进风电行业发展，为实现碳达峰、碳中和提供有力保障。

      传统热处理存在加热均匀性差、加热温度可控性差、能量利用率低等痛点。超导直流感应加热技术是基于超导材料零电阻和高载流特性，利用高温超导磁体产生背景磁场，在加热区域建立直流气隙磁场，坯料旋转切割磁力线产生涡流被加热，以实现高穿透性、高能效性、高均匀性、高梯度性的全新高品质加热，为金属热加工行业提供了一种创新的解决方案。

      自2013年美国Elon Musk公布了关于Hyperloop真空管道列车的方案后，"高速交通"这一概念受到越来越多的关注。2014年，日本东京至大阪的低温超导高速磁浮应用线路已经开工建设，在试验轨道上以时速603公里创下世界纪录。目前，德国、巴西、我国等都在进行高温超导磁悬浮环形线的研究。高温超导磁悬浮技术采用高温超导带材线圈作为其定子或动子，大气隙工作条件下仍能保证较高的功率因数，可显著提升牵引力、载重、速度，同时减重减体积、大幅节能，并降低制冷成本，能耗更低。随着未来城市的快速发展，超导磁悬浮这种快速、安全、清洁的交通方式，将为落实"交通强国"战略提供技术支撑。
      `
        },
        cases: {
          title: '应用案例',
          list: [
            {
              title: '35.6全超导用户磁体——中国科学院电工研究所/中国科学院物理研究所',
              content: `中国科学院电工研究所团队依托国家重大科技基础设施-综合极端条件实验装置，实现了35.6特斯拉(T)全超导磁体，创造了全超导用户磁体新的世界纪录。该全超导磁体中心磁场达35.6特斯拉，可用孔径为35毫米，是支持国内外科研团队开展前沿研究的用户磁体。

上海超导荣幸地为该磁体供应了超导材料，并参与到这一新纪录的诞生，公司所提供的高一致性大长度带材有力支撑了该磁体的成功研制。用户磁体需要长时间、反复使用，能够选用上海超导的带材是客户单位对我司产品长期服役状态下的稳定性的充分肯定。`,
              image: '/images/applications/位于怀柔综合极端条件实验装置的全超导强磁场磁体系统在励磁过程中.jpg'
            },
            {
              title: '32.35T磁体项目——中科院电工研究所',
              content: `中科院电工所团队于2019年12月成功研制出中心磁场高达32.35T的全超导磁体，打破了当时32.0T超导磁体的世界纪录。

    上海超导与中科院电工所团队建有长期合作关系，为其提供部分高温超导带材，用于绕制磁体端部的2个线饼。`,
              image: '/images/applications/32.35T磁体项目.png'
            },
            {
              title: '35.1T全超导磁体——中科院等离子体所',
              content: `中科院等离子体所及其联合研发团队于2025年9月共同研制的全超导磁体，成功励磁至35.1特斯拉，稳定运行30分钟后安全退磁，充分验证了技术方案的可靠性，为在全超导磁体35.1T条件下开展各类样品实验提供了强有力平台。

上海超导与中科院等离子体所长期合作，提供了该磁体绕制所需全部REBCO高温超导带材。`,
              image: '/images/applications/35.1T全超导磁体——中科院等离子体所.png'
            },
            {
              title: '44.86T内插高温超导线圈——中科院合肥物质所强磁场中心',
              content: `中国科学院合肥物质院强磁场中心于2025年9月成功绕制“口袋”型内插高温超导线圈，该线圈在液氦零背景场下产生28.20 T磁场，并在稳态强磁场实验装置WM5水冷磁体34.5 T的背景场下产生10.36 T磁场，总体磁场达44.86T。
上海超导与强磁场中心紧密合作，提供了该磁体绕制所需的全部高温超导带材。`,
              image: '/images/applications/44.86T内插高温超导线圈——中科院合肥物质所强磁场中心.png'
            },
            {
              title: '26.8T全REBCO高温超导磁体——中科院等离子体所',
              content: `中科院等离子体所及其联合研发团队于2024年1月成功将研制的全REBCO高温超导磁体励磁至26.8T，打破了全高温超导磁体26.4T最高记录，标志着我国高温超导磁体技术及高温超导材料性能均达到国际领先水平。

    上海超导提供了该磁体绕制所需的多种规格的高性能高温超导带材，为磁体的成功研制提供了关键的材料保障。上海超导将继续深化与等离子体所的合作，为高温超导磁体技术的发展和创新做出更大贡献。`,
              image: '/images/applications/26.8T全REBCO高温超导磁体.png'
            },
            {
              title: '24.1T全REBCO高温超导磁体——中科院等离子体所',
              content: `中科院等离子体所团队于2022年10月成功将自主研制的全REBCO高温超导磁体励磁至24.1T，这是国内首个20T以上全REBCO密绕型超导磁体。该磁体在液氦浸泡条件下，成功升流至300A，中心场强稳定保持在24.1T。

    该磁体使用的REBCO超导带材全部由上海超导公司提供，证明了国产REBCO带材在低温高磁场下的优异性能。本磁体的研制对于推动国内超导材料和超导磁体装备的发展具有重要意义，为后续研制35T以上高场科学装置奠定了重要基础。`,
              image: '/images/applications/24.1T全REBCO高温超导磁体.png'
            },
            {
              title: '国内首套高温超导电动悬浮列车——中车集团',
              content: `中车长客自主研制的国内首套高温超导电动悬浮全要素试验系统于2023年3月在长春完成首次悬浮运行，对高温超导磁体、直线同步牵引等超导电动悬浮交通系统的关键核心技术进行了充分验证，标志着我国在高温超导电动悬浮领域实现重要技术突破。

    上海超导与中车长客深度合作，作为核心材料供应商为该项目提供了全部高性能高温超导材料，并在多年的联合攻关团队中，深度参与了车载高温超导磁体等多个关键部件的开发。后续上海超导将跟随由中车牵头的联合团队，在更大尺寸、更高速度的超导电动磁浮样车研制工作中做出贡献。`,
              image: '/images/applications/国内首套高温超导电动悬浮列车.png'
            },
            {
              title: '兆瓦级超导感应加热器——江西联创超导',
              content: `江西联创超导成功研制世界首台兆瓦级高温超导感应加热装置、并于2023年4月20日在黑龙江中铝集团东北轻合金公司成功投运。该产品为高效节能的感应加热炉，可广泛应用与多种金属加工和热处理领域，实现近50%的节能效果和超均匀的加热效果。   

   上海超导与江西联创光电长期合作，作为核心材料供应商，为其供应了从原理样机研制阶段到工业产品定型阶段全部高温超导带材，用于感应加热器核心磁体绕制，目前上海超导已完成供应百公里级别的高温超导带材。`,
              image: '/images/applications/兆瓦级超导感应加热器.png'
            },
            {
              title: '高温超导磁控硅单晶生长技术通过专业鉴定-江西联创超导',
              content: `2025年3月，“高温超导磁控硅单晶生长装备、技术及应用科技成果鉴定会”顺利召开，由中国科学院院士甘子钊领衔的专家委员会对项目展开全面评估，并一致认为该技术填补了我国在高端硅晶体制造领域的多项空白，综合性能达到国际领先水平。   

   作为联创超导的核心材料供应商，上海超导已为其供应了1000多公里高性能高温超导带材，应用于绕制高温超导感应加热装置和高温超导磁控硅单晶生长装备的超导磁体。`,
              image: '/images/applications/超导单晶炉.jpg'
            },
            {
              title: 'MRI超导磁体——英国剑桥大学',
              content: `英国剑桥大学在2021年成功研制了一款小型MRI设备，该设备设计专用于头颅MRI成像，以快速判断中风等病症。该设备内部的磁体全部采用上海超导生产的第二代高温超导带材，在工作温度20K下可产生1T的磁场强度，设备体积较小、重量轻，可快速移至病床边提供检测服务，具有高效性、便携性等显著优势。
   上海超导与英国剑桥大学深度合作，为其提供了该小型MRI设备的全部高温超导带材，用于MRI磁体的绕制。`,
            
            }
          ]
        }
      },
      power: {
        title: '超导电力',
        introduction: {
          title: '引言',
          content: ` 随着商业、居民及新能源汽车用电量快速攀升，全球各地大中城市的峰值用电负荷已逼近城市供电能力的极限。漫天的架空线，拥挤的地下电缆，使得如何更稳定、有效地向城市中心输电成为各国电网发展的难题。高温超导材料的发展，使得超导技术的应用进一步延伸到电力工业中，也给部分电力装备的弊端提供新的解决方案。超导技术在电力中的应用主要包括：超导电缆、超导限流器、超导储能装置和超导电机等。

      超导电缆利用高温超导带材特性，具有传输容量大、损耗低、可靠性高、廊道占地小、环境友好等优点。超导材料的载流能力为同尺寸铜线的50-500倍，工程载流量提升5-10倍，使得超导电缆城市密集商业区、居住区、工业区和超大型高层建筑等已有线路的扩容、大电流传输等应用场景具备显著优势价值。

      高温超导限流器被认为是目前最有效的电力短路故障电流限制装置。装置运行时阻抗极小，出现故障时阻抗自动增大，并具有百微秒级响应速度和自动限流的特点，可长期、重复使用。超导限流器的应用，可整体提高电网的稳定性、改善供电的可靠性和安全性。

      近年来我国超导电力应用加速推进，国家电网和南方电网都着力发展多种高温超导电力设备，目前我国已经在上海和深圳两地投运了两条商业运行的高温超导电缆示范线，220kV交流、500kV交流和160kV直流的超导限流器也相继研发成功，南方电网在十四五期间已经重点展开10Mvar等级超导调相机和10MJ等级超导储能的研制。多条传输距离更长、载流能力或电压等级更高的超导电缆输电工程也在广东、上海、浙江等地紧罗密布的筹备中。超导电力应用的赛道将在未来几年迅速铺开。`
        },
        cases: {
          title: '应用案例',
          list: [
            {
              title: '国内首条35千伏公里级高温超导电缆示范工程——国家电网/上海电缆研究所/上海国际超导公司',
              content: `示范工程位于上海市徐汇区长春变电站和漕溪变电站两座220千伏变电站之间，线路全长1.2公里，设计电流2200安培，是目前世界上输送容量最大、线路最长、全商业化运行的35千伏高温超导电缆，于2021年12月22日正式在沪投运。

上海超导为该项目提供将近160公里ST-05-L型高性能高温超导带材，该电缆工程的通电导体层全部采用我公司生产的带材。`,
              image: '/images/applications/国内首条35千伏公里级高温超导电缆示范工程.png'
            },
            {
              title: '国内首条10千伏三相同轴高温交流超导电缆——南方电网/中天科技',
              content: `该条三相同轴高温超导电缆于2021年9月28日投运，为深圳平安金融中心带来高可靠性供电。这也是全球首个应用于超大型城市中心区的超导电缆，有望"一揽子"解决大城市电网建设用地难、电网负荷需求持续增长、城市输配电走廊趋于饱和等诸多问题和挑战。

该项目的全部超导材料均为上海超导供应，且上海超导在2021年1月至3月期间，仅用2个月左右生产周期就为该项目成功交付110余公里ST-05-L型高性能高温超导带材。`,
              image: '/images/applications/国内首条10千伏三相同轴高温交流超导电缆.png'
            },
            {
              title: '160kV直流电阻型超导限流器——广东电网',
              content: `该项目是南方电网牵头的国家重点研发计划项目，也是世界电压等级最高、容量最大的超导直流限流器，可有效增强直流输电的电网安全保护能力，已于2019年1月通过第三方测试、2020年8月挂网试运行。

上海超导为该项目特殊研制并批量供应了双层封装型超导带材，可同时实现高室温电阻率（提升限流效果）和超强耐冲击稳定性（增强设备可靠性）。2019年上海超导按时完成该项目数十公里10mm宽双层封装带的批量供货（相当于近200km超导电缆用4mm宽带材的供货量），助力该项目的成功实施。`,
              image: '/images/applications/160kV直流电阻型超导限流器.png'
            },
            {
              title: '220kV交流电阻型超导限流器——中天科技/中科院电工所/北京交通大学',
              content: `该项目为我国十三五期间超导领域的重要项目，国家863计划，于2018年1月通过验收。该项目的成功为后续电阻型超导限流器的电网应用奠定了坚实的基础。

该项目的超导材料全部由上海超导提供，我司为项目供应了近二十公里12mm宽不锈钢封装高温超导带材。`,
              image: '/images/applications/220kV交流电阻型超导限流器.png'
            },
            {
              title: '500kV交流饱和铁芯型超导限流器——广东电网',
              content: `该项目是国内首台自主研发的、国际上电压等级最高的500kV超导限流器，突破了大尺寸高温超导磁体设计与制造等关键技术瓶颈，并实现了稳定运行，于2017年7月通过验收。

该项目的研制阶段（2016年）正逢上海超导的带材产品刚打破国际垄断，实现小批量供应能力。得益于南方电网对国产核心原材料的信任与支持，在线圈端部高磁场区域采用了上海超导的材料（其余材料仍为日本进口）。该项目也是国产二代高温超导带材产品首次在我国大型超导电力设备中的应用。`,
              image: '/images/applications/500kV交流饱和铁芯型超导限流器.png'
            },
            {
              title: '电阻式超导限制器-法国SuperGrid Institute',
              content: `SuperGrid Institute采用电阻式超导限流器与直流断路器相结合的技术方案，于2024年12月成功实现50kV直流分断，验证了该方案的技术可行性。该方案可将地面直流保护设备尺寸减小40-50%，适用交流和直流工况，在海上电力系统应用领域具有显著优势。

上海超导自2023年起与SuperGrid Institute建立合作，目前已为该项目提供数公里高性能高温超导带材。`,
                  image: '/images/applications/电阻式超导限制器.png'
            }, 
            {
              title: '10kV/1MVar级高温超导并联电抗器——国网上海电力公司/翌曦科技',
              content: `该项目由国网上海电力公司牵头，是全球首台环形超导电抗器，10千伏电压等级，设计容量为1Mvar，是我国在超导电力设备领域的最新研发成果之一，于2025年7月通过型式试验，将在上海市徐汇中心城区投入运行。

该项目的超导材料全部由上海超导提供，我司为项目供应了近五十公里4.8mm宽紫铜封装高性能高温超导带材。`,
                  image: '/images/news/上海超导持续助力超导应用创新发展1.png'
            }
          ]
        }
      },
      nuclear: {
        title: '可控核聚变',
        introduction: {
          title: '引言',
          content: `"清洁"、"安全"、"无限"，核聚变被认为是人类能源的终极解决方案。1克聚变物质可以释放9万千瓦时的电力… …

      随着全球对清洁能源需求的不断增长，核聚变作为未来能源的终极解决方案之一，正受到越来越多的关注。

      根据聚变行业协会（Fusion Industry Association，FIA）《2024年全球聚变行业报告》，聚变产业从2021年至2024年已累计吸引了超过71亿美元的投资，2024年新增9亿美元投资，其中政府资助增加至4.26亿美元、增幅57%；全球范围内的私营聚变公司也随之增加到45家，其中美国占据主导地位、有25家；其次是英国、德国、日本和中国等国家。

      根据国际原子能机构（IAEA）发布的数据，截至2024年，全球在运营的核聚变装置有102座，在建核聚变装置有16座，计划建设的装置则有48座。其中，公用事业机构旗下的核聚变装置总数为115座、私营公司主导的核聚变装置总数为51座，中国、法国、美国、英国、德国、日本、俄罗斯、韩国、加拿大、荷兰、印度等国家都拥有核聚变试验装置。

      2024年，公-公合作、公-私合作均迎来了跨越式式发展。公-公合作方面，日本成立聚变产业委员会J-Fusion、欧洲成立核聚变协会；继2023年英美确立聚变能源战略伙伴关系后，2月英国和加拿大在聚变能源方面确认新伙伴关系；4月美国DOE与日本文部科学省建立战略伙伴关系。公-私合作方面，值得注意的有美国里程碑核聚变开发计划（Milestone-based fusion development program）、德国政府的新“核聚变2040”计划（new "Fusion 2040"）、日本政府的新“核聚变登月”目标（new "Fusion Moonshot goal"）、英国政府的新“核聚变未来”计划(new "Fusion Futures" program)，拟投资于关键技术提供商。根据这些计划，公-私合作陆续开展，EUROfusion和Fusion for Energy（F4E）联合推出欧洲聚变技术市场平台，英国TE公司与英国、美国政府将在ST40升级、首个聚变能源创新项目LEAPS两个项目展开合作，国际组织ITER也宣布了它对公私合作伙伴关系的兴趣，并打算直接与私营聚变公司分享知识。

      国内外在核聚变研究领域均取得了显著进展，商业化进程也在加速推进。

      2025年以来，中国全超导托卡马克装置EAST实现1亿度等离子体持续运行1066秒，再次创造托卡马克装置高约束模运行新的世界纪录；新一代装置“中国环流三号”（HL-3）首次实现离子温度1.17亿度、电子温度1.6亿度的“双亿度”参数水平，标志着中国可控核聚变向工程化应用迈出重要一步，随后“中国环流三号”再次创下我国聚变装置运行新纪录——实现百万安培亿度高约束模（H模），即装置同时实现等离子体电流100万安培、离子温度1亿度、高约束模式运行，综合参数聚变三乘积再创新高，达到10的20次方量级；能量奇点自主研制的大孔径强场磁体——经天磁体成功完成了首轮通流实验，产生了高达21.7特斯拉的磁场，创下大孔径高温超导D形磁体最高磁场纪录；BEST项目工程总装正式启动，2027年建成后将会成为世界首个紧凑型聚变能实验装置。

      国际方面，法国WEST装置成功将氢等离子体维持1337秒，加热功率高达2兆瓦；美国Helion Energy公司计划2028年在华盛顿建成全球首座50MW聚变电厂；美国CFS公司SPARC装置超50%环向场磁体完工、目标2026年实现等离子体运行，ARC商业堆选址完成、设计供电15万户；德国Proxima Fusion公司推出全球首个“Stellaris”仿星器核聚变电厂概念设计；英国STEP项目公布建设和工程合作伙伴名单，标志着STEP项目进入了新的阶段。

      每一步，都在强化着几十年的技术突破和积累，都在完善着核聚变的伟大图景。

      已故苏联物理学家、托卡马克装置发明人之一的列夫•阿尔茨莫维奇(Lev Artsimovich)说过：当社会需要核聚变时，核聚变就会准备好。`
        },
        cases: {
          title: '应用案例',
          list: [
            {
              title: '可控核聚变项目——美国Commonwealth Fusion Systems公司',
              content: `美国CFS公司使用高温超导带材绕制大口径、20T的强磁场磁体，将应用于SPARC、ARC超导核聚变等，第一阶段磁体已于2021年9月宣布测试成功。

上海超导已为该项目批量提供超过一百余公里采用30微米超薄基带的高性能高温超导带材，用于聚变导体和磁体研制。`,
              image: '/images/applications/可控核聚变项目——美国Commonwealth Fusion Systems公司.png'
            },
            {
              title: '可控核聚变项目——英国Tokamak Energy公司',
              content: `托卡马克能源公司ST-40球形托克马克反应堆于2022年3月实现1亿摄氏度的温度，成为商业化核聚变研究的重要里程碑。

上海超导与英国TE公司进行深度合作，于2017-2020年间分批陆续供应宽幅高性能高温超导带材，用于强场磁体研制及超导可控核聚变。`,
              image: '/images/applications/可控核聚变项目——英国Tokamak Energy公司.png'
            },
            {
              title: '洪荒70装置、21.7T经天磁体——能量奇点',
              content: `能量奇点于2024年6月成功实现全球首台全高温超导磁约束聚变装置——洪荒70的等离子体放电，在全球范围内率先完成了高温超导托卡马克的工程可行性验证。2025年3月，能量奇点经天磁体成功完成首轮通流实验，磁场强度达21.7T，创下目前大孔径高温超导D形磁体最高磁场纪录。

上海超导与能量奇点紧密合作，建立了良好的合作模式，并作为核心材料供应商，为洪荒70装置、经天磁体提供全部的高性能高温超导带材。`,
              image: '/images/applications/能量奇点洪荒70和21.7T经天磁体.png'
            },
            {
              title: '可控核聚变项目——星环聚能',
              content: `星环聚能于2023年成功研制了D形高温超导磁体原理样机，磁体内最高场强达18T。2024年，星环聚能自主开发了高温超导磁体运行监控及保护系统，SH-150亥姆霍兹磁体可提供孔径150 mm的均匀磁场，为第一饼聚变级球形托卡马克环向磁体的制造和测试打下基础。

上海超导与星环聚能紧密合作，已向其批量供应高性能高温超导带材，用于高温超导线圈绕制。`,
              image: '/images/applications/星环聚能.png'
            },
            {
              title: '国内首根百米级高载流高温超导导体——南方电网',
              content: `2025年10月，南方电网成功研制基于CORC（圆芯电缆）与TSTC（堆叠电缆）两种子缆结构的两根百米级大电流高温超导导体，并通过测试与验收。在液氮温度自场下载流量达到20千安，在液氦温度15特斯拉磁场下载流量超过50千安，以“长度最长、载流量最高”的优势刷新高温超导大电流导体技术纪录，标志着我国百米级的大电流高温超导导体研究获得了成功。

上海超导与南方电网紧密合作，为该项目提供了项目所需的全部高温超导材料，在子缆和导体的研究工作中发挥了重要支撑作用。`,
              image: '/images/applications/国内首根百米级高载流高温超导导体——南方电网.png'
            }
          ]
        }
      }
};